<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Now, Think of a Question that Is at Stake for You</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Work session, installation, system administration</p>
        <p>
rosa is a feminist server that travels between different locations, providing a mobile infrastructure for learning,
documentation, and experiments for the meetings that happened during the A Traversal Network of Feminist Servers project. rosa is not
only its constituting hardware or software, but also the multitude of relations which are created around the making, maintaining and passing
on of this infrastructure: the processes that are performed, the affective charge of their actioning, the communities around
them.
</p>

<p>In January and February 2023, the window of Constant became a space for exploring the possibilities
of shifting languages within a shared server. Vernaculars have developed from each situated iteration in Rotterdam (Varia, LURK),
Bucharest (hypha), Graz (esc mkl), Athens(Feminist Hack Meetings) and Brussels (Constant), accompanied by artists and researchers
Marloes de Valk and ooooo. What languages compose rosa as a space beyond those that were inherited through their operating system
and their dependencies? How can these languages be questioned and rewritten ?</p>
        <p>The
installation Now, think of a question that
is at stake for you is part of Constant_V,
a series of small exhibitions with a view
on Free, Libre and Open Source culture. </p>
        <p>The session and installation were developed together with Cristina Cochior.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/rosa/diagram-rosa.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/rosa/window.JPG"></b-img>


      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/rosa/question.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/rosa/question2.png"></b-img>



      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ATNOFSPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
